/* eslint-disable */
import { useState, useEffect, useContext } from "react";
// import { Nav, Navbar, Container, NavDropdown, Dropdown } from "react-bootstrap";
import "./Navigation.css";
import Loading from "../../Loading";
import AuthContext from "../../../../context/AuthProvider";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../../../assets/logo.png";
import { Fragment } from "react";
import { Disclosure, Menu, Transition, Dialog } from "@headlessui/react";
import { MdDeleteOutline } from "react-icons/md";
import { ExclamationTriangleIcon  } from "@heroicons/react/24/outline";
import EditIcon from "../../../../assets/edit-2.svg"


import {
  Bars3Icon,
  BellIcon,
  XMarkIcon,
  CalendarIcon,
  ChartPieIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { Link, FileEarmarkArrowUp, TextLeft, PersonLinesFill, Brush, Code, Receipt, Bell, Calendar2Check , Calendar3, UsbSymbol, People, Eye, Sliders, Diagram3, Person, GraphUp, Bezier2, ClockHistory, Search, Hexagon, Palette, ChatSquareText } from 'react-bootstrap-icons';

//Redux-imports
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardContent,
  setEditAsset,
  logout,
} from "../../../../redux/actions/assetLibActions";
import {
  createTemplate,
  createDeal,
} from "../../../../redux/actions/dealRoomActions";
import Cookies from "js-cookie";
import { cleanChatHistory, deleteChat, setListingData } from "../../../../redux/actions/queryZoiAction";
import { FiInfo } from "react-icons/fi";
import { getCustomerBranding } from "../../../../api/customerSiaApi";


const Navigation = (props) => {
  
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const ctx = useContext(AuthContext);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sideHistoryOpen, setSideHistoryOpen] = useState(false);
  let { id } = useParams();
  const authToken = props.authToken;
  const [active, setActive] = useState("default");
  const [show, setShow] = useState(false);
  const [ptoken, setPToken] = useState("");
  const [brandingLogo, setBrandingLogo] = useState("");
  const userData = useSelector((state) => state.assetLibrary.userData);
  const zoomCode = useSelector((state) => state.dealRoom.zoomCode);
  const chat_history = useSelector((state) => state.queryzoi.chat_history?.details);
  const uData = JSON.parse(localStorage.getItem("userData"))
 const rValues = uData?.data
  const userType = localStorage.getItem("userType")
    ? localStorage.getItem("userType")
    : "";
  const navigation = userType == "3" ? [
    {
      title:rValues?.dashboard && "Dashboard",
      route: rValues?.dashboard && "/Analytics",
      sub_menu: [
        { name: "Analytics", href: "/Analytics", icon: GraphUp, current: "user" },
      ],
    },
    {
      title: "TrainAI",
      route: "/Chat-Ai",
      sub_menu: [
        { name: "URL", href: "/Chat-Ai", icon: Link, current: "url" },
        {
          name: "Assets",
          href: "/Chat-Ai/assets",
          icon: FileEarmarkArrowUp,
          current: "assets",
        },
        {
          name: "Notepad",
          href: "/Chat-Ai/text",
          icon: TextLeft,
          current: "text",
        },
        rValues?.fine_tune && {
          name: 'Fine Tuning',
          href: '/Chat-Ai/tuning',
          icon: Bezier2,
          current: "tuning"
        },
        // rValues?.lead_capture &&{
        //   name: "Lead Capture",
        //   href: "/Chat-Ai/engage",
        //   icon: PersonLinesFill,
        //   current: "engage",
        // },
        {
          name: "Design",
          href: "/Chat-Ai/design",
          icon: Brush,
          current: "design",
        },
        rValues?.developer && { name: 'Developer', href: '/Chat-Ai/developer', icon: Code, current: "developer" },
      ].filter(Boolean),
    },
    {
      title:rValues?.conversation && "Conversation",
      route:rValues?.conversation && "/Conversation",
      sub_menu: [
        { name: "Review", href: "/Conversation", icon: Eye, current: "user" },
      ],
    },
    {
      title:rValues?.intent &&  "Intent",
      route:rValues?.intent &&  "/Intel",
      sub_menu: [
        { name: "Intel", href: "/Intel", icon: Hexagon, current: "intel" },
      ],
    },
    {
      title: uData?.data?.admin_ama === true && "Ask SIA",
      route: uData?.data?.admin_ama === true && "/internal_ama",
      sub_menu: uData?.data?.admin_ama === true && [
        { name: "Home", href: "/internal_ama", icon: HomeIcon, current: "user" },
      ],
    },
    {
      title: "Lead Management",
      route: "/Lead-Management",
      sub_menu: [
        { name: "Lead View", href: "/Lead-Management", icon: Person, current: "user" },
        { name: "Account View", href: "/Account", icon: Diagram3, current: "user" },
      ],
    },
    {
      title: "User Settings",
      route: "/Setting",
      sub_menu: [
        { name: 'Users', href: '/Setting', icon: People, current: "user"},
        { name: 'Setup', href: '/Setting/setup', icon: Palette, current: "setup"},
        { name: 'Recommended Questions', href: '/Setting/recommendedQuestions', icon: ChatSquareText, current: "recommendedQuestions"},
        { name: 'General', href: '/Setting/account', icon: Sliders, current: "account"},
        { name: 'Plans & Billing', href: '/Setting/billing', icon: Receipt, current: "billing"},
        { name: 'Appointment', href: '/Setting/selectCalendar', icon: Calendar2Check, current: "selectCalendar"},
        { name: 'Notification Center', href: '/Setting/notification', icon: Bell, current: "notification"},
        { name: 'Calendly', href: '/Setting/calendly', icon: Calendar3, current: "calendly"},
        { name: 'Hubspot', href: '/Setting/hubspot', icon: UsbSymbol, current: "hubspot"},
      ]
    }
  ]

    :
  
  [
    {
      title:rValues?.dashboard && "Dashboard",
      route:rValues?.dashboard && "/Analytics",
      sub_menu: [
        { name: "Analytics", href: "/Analytics", icon: GraphUp, current: "user" },
      ],
    },
    {
      title:rValues?.conversation && "Conversation",
      route:rValues?.conversation && "/Conversation",
      sub_menu: [
        { name: "Review", href: "/Conversation", icon: Eye, current: "user" },
      ],
    },
    {
      title: "Lead Management",
      route: "/Lead-Management",
      sub_menu: [
        { name: "Lead View", href: "/Lead-Management", icon: Person, current: "user" },
        { name: "Account View", href: "/Account", icon: Diagram3, current: "user" },
      ],
    },
  ]
  const navLogo =
    brandingLogo || userData?.client_details?.company_logo;

  useEffect(() => {
    const loadBrandingLogo = async () => {
      if (!authToken) return;
      try {
        const res = await getCustomerBranding(authToken);
        if (res?.data?.statusCode === "200") {
          setBrandingLogo(res?.data?.data?.logo || "");
          document.documentElement.style.setProperty(
            "--brand-primary",
            res?.data?.data?.primary_color || "#59B3C6"
          );
          document.documentElement.style.setProperty(
            "--brand-secondary",
            res?.data?.data?.secondary_color || "#000000"
          );
        }
      } catch (e) {
        setBrandingLogo("");
        document.documentElement.style.setProperty("--brand-primary", "#59B3C6");
        document.documentElement.style.setProperty("--brand-secondary", "#000000");
      }
    };
    loadBrandingLogo();
  }, [authToken]);

  const dealRoomSwitch = useSelector(
    (state) => state.assetLibrary.dealRoomSwitch
  );
  const getInitials = (firstName, lastName) => {
    if(firstName?.length > 0){
      var initials =
        firstName?.charAt(0).toUpperCase() + lastName?.charAt(0).toUpperCase();
    }else{
      var initials =
        userData?.email?.charAt(0).toUpperCase() + userData?.email?.charAt(1).toUpperCase();
    }
    return initials;
  };

  useEffect(() => {
    dispatch(fetchDashboardContent(authToken));
  }, []);

  // useEffect(() => {
  //   if (zoomCode) {
  //     navigate("/dealroom-deal");
  //   }
  // }, [zoomCode]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  
  const redirectHome = () => {
        const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
        const randomIdQuery = Math.floor(Math.random() * 900000) + 100000;
        Cookies.set("qzoi", `q-zoi-${randomIdQuery}`, { expires: expiryDate });
        setSideHistoryOpen(false);
        dispatch(setListingData());
        navigate(`/internal_ama`);
  };

  const tokenData = useSelector((state) => state.chatAi.tokenData);
  const totalData = useSelector((state) => state.chatAi.tData);

  const handleClear = () => {
    dispatch(cleanChatHistory(authToken));
  }


  const handleDelete =(p_token) =>{
    setShow(true);
    setPToken(p_token);
    setSideHistoryOpen(false);
  }
 const handleClose = () =>{
  setShow(false);
  setPToken("")
 }

 const deleteEvent = () =>{
  dispatch(deleteChat(authToken,ptoken));
  setShow(false);
  redirectHome();
 }

 const [mobileView, setMobileView] = useState(false)

  useEffect(() => {
    
    if (window.innerWidth <= 768) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, []);


  return (
    <>
      <Disclosure as="nav" className="bg-white shadow fixed w-full z-10">
        {({ open }) => (
          <>
            <div className="mx-auto w-full px-2 sm:px-6 lg:px-8">
              <div className="relative flex h-16 justify-between">
                <div className="absolute inset-y-0 left-0 items-center max-md:flex hidden">
                  {/* Mobile menu button */}
                  <div className="flex items-center sticky top-0 z-40 h-16 shrink-0 gap-x-4 border-b border-gray-200 bg-white px-2 shadow-sm sm:gap-x-6 sm:px-6 lg:px-4">
                    {window.location.pathname.includes("internal_ama") && <Bars3Icon onClick={()=>{setSideHistoryOpen(true)}} className='hidden h-6 w-6 max-sm:block text-[#000]'/>}
                    {/* <button
                      type="button"
                      className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
                      onClick={() => setSidebarOpen(true)}
                    >
                      <span className="sr-only">Open sidebar</span>
                      <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button> */}
                    {/* Separator */}
                  </div>
                  {navLogo && <>
                  {/* <img
                      className="header-logo w-20 h-[3rem]"
                      src={userData && userData?.client_details?.company_logo}
                      alt={userData && userData?.client_details?.company_name}
                    /> */}
                    <img
                      className="header-logo h-16 "
                      src={navLogo}
                      alt="logo"
                    />
                  </>}
                </div>

                <div className="absolute inset-y-0 left-0 flex items-center max-sm:hidden">
                  {navLogo && <a
                    href="/internal_ama"
                    className="flex flex-shrink-0 items-center"
                  >
                    <img
                      className="header-logo h-16"
                      src={navLogo}
                      alt="logo"
                    />
                  </a>}
                </div>
                <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-center">
                  <div className="max-md:hidden sm:ml-6 flex sm:space-x-8">
                    {/* {rValues?.dashboard && <span
                      onClick={() => {
                        navigate("/Analytics");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        props.pageType === "Analytics"
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Dashboard
                    </span>} */}
                   {/* {userType == "3" && <span
                      onClick={() => {
                        navigate("/Chat-Ai");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        props.pageType === "Chat Ai"
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      TrainAI
                    </span>} */}
                    {/* {dealRoomSwitch && (
                      <span
                        onClick={() => {
                          navigate("/Deal-Room");
                        }}
                        className={`inline-flex cursor-pointer items-center border-b-2 ${
                          props.pageType === "Deal Room"
                            ? "border-[var(--brand-primary)] text-[#111827]"
                            : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                        }  px-1 pt-1 text-sm font-medium  `}
                      >
                        Deals
                      </span>
                    )} */}
                    {/* {rValues?.conversation && <span
                      onClick={() => {
                        navigate("/Conversation");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        props.pageType === "Conversation"
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Conversation
                    </span>}
                    {<span
                      onClick={() => {
                        navigate("/journey");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        props.pageType === "Journey"
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Journey
                    </span>}
                    <span
                      onClick={() => {
                        navigate("/Lead-Management");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        (props.pageType === "Lead Mangement" || props.pageType === "Account Mangement")
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Lead Management
                    </span> */}
                    
                    {/* {uData?.data?.admin_ama === true && <span
                      onClick={() => {
                        navigate("/internal_ama");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        (props.pageType === "Internal AMA")
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Query Zoi
                    </span>} */}
                    
                    {uData?.data?.live_chat === true && <span
                      onClick={() => {
                        navigate("/livechat/conversations/mine");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        (props.pageType === "Live Chat")
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Live Chat
                    </span>}
                    {rValues?.intent && <span
                      onClick={() => {
                        navigate("/Intel");
                      }}
                      className={`inline-flex cursor-pointer items-center border-b-2 ${
                        props.pageType === "Intel"
                          ? "border-[var(--brand-primary)] text-[#111827]"
                          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"
                      }  px-1 pt-1 text-sm font-medium  `}
                    >
                      Intel
                    </span>}
                    {/* <a
                    href="/Asset-Library"
                    className={`inline-flex items-center border-b-2 ${props.pageType === "Asset Library" ? "border-[var(--brand-primary)] text-[#111827]" : "border-transparent text-gray-500 hover:border-gray-300 hover:text-[var(--brand-secondary)]"}  px-1 pt-1 text-sm font-medium  `}
                  >
                    Asset
                  </a> */}
                  </div>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                  {/* <button
                    type="button"
                    className="relative max-sm:hidden rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                  {uData?.stripeData?.is_trial == 1 && uData?.stripeData?.stripe_day_count > 0 && <span onClick={()=>{navigate("/Setting/billing")}} className={`text-xs ${"bg-[#49BCD2]"} p-2 rounded-sm text-white`}>
                  {`Trial Period Expires in ${uData?.stripeData?.stripe_day_count} Days`}
                    </span>}
                    {uData?.stripeData?.is_trial == 1 && uData?.stripeData?.stripe_day_count == 0 &&<span onClick={()=>{navigate("/Setting/billing")}} className={`text-xs ${"bg-red-500"} p-2 rounded-sm text-white`}>
                    Trial Expired. Go to Billing.
                    </span>}
                </button> */}

                  {/* {window.location.pathname.includes("internal_ama") && <ClockHistory onClick={()=>{setSideHistoryOpen(true)}} className='hidden max-sm:block text-3xl text-[var(--brand-primary)]'/>} */}
                  
                  {/* Profile dropdown */}
                  {userData?.user_type == 4 ? 
                    <div onClick={() => navigate("/internal_ama")}>
                      <img className="w-8 h-8" src={EditIcon} />
                    </div>
                     :<Menu as="div" className="relative ml-3">
                    <div>
                      <Menu.Button className="relative flex rounded-full bg-white text-sm focus:outline-none ">
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        {userData && (
                          <div
                            className="bg-[var(--brand-primary)] p-[0.4rem] rounded-full"
                            title={
                              userData?.first_name + " " + userData?.last_name
                            }
                          >
                            {getInitials(
                              userData?.first_name,
                              userData?.last_name
                            )}
                          </div>
                        )}
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        
                      
                        <Menu.Item>
                          {({ active }) => (
                            <span
                              onClick={() => {
                                dispatch(logout(authToken));
                                ctx.onLogout();
                                Cookies.remove("currentURL");
                              }}
                              className={classNames(
                                active
                                  ? "bg-gray-100 cursor-pointer"
                                  : "cursor-pointer",
                                "block px-4 py-2 text-sm text-gray-700"
                              )}
                            >
                              Sign out
                            </span>
                          )}
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>}
                </div>
              </div>
            </div>
            
            <Transition.Root show={sideHistoryOpen} as={Fragment}>
              <Dialog as="div" className="relative z-50 lg:hidden" onClose={setSideHistoryOpen}>
                <Transition.Child
                  as={Fragment}
                  enter="transition-opacity ease-linear duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="transition-opacity ease-linear duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-gray-900/80" />
                </Transition.Child>

                <div className="fixed inset-0 flex">
                  <Transition.Child
                    as={Fragment}
                    enter="transition ease-in-out duration-300 transform"
                    enterFrom="-translate-x-full"
                    enterTo="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leaveFrom="translate-x-0"
                    leaveTo="-translate-x-full"
                  >
                    <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                          <button type="button" className="-m-2.5 p-2.5" onClick={() => setSideHistoryOpen(false)}>
                            <span className="sr-only">Close sidebar</span>
                            <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                          </button>
                        </div>
                      </Transition.Child>
                      {/* Sidebar component, swap this element with another sidebar if you like */}
                      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white pl-6 pb-4">
                        <div className="h-16 shrink-0 items-center">
                          <div
                            onClick={() => {
                              navigate("/");
                              setSideHistoryOpen(false);
                            }}
                            className="border-b mb-4 border-gray-200 flex-shrink-0 pt-4 pb-6 items-center"
                          >
                            <img className="header-logo w-20" src={navLogo} alt={userData && userData?.client_details?.company_name}/>
                          </div>
                          <div className="lg:fixed lg:inset-y-[13%] lg:z-10 lg:flex lg:w-72 lg:flex-col">
                              {/* Sidebar component, swap this element with another sidebar if you like */}
                              <div className="flex flex-col justify-between">
                              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white pb-4">
                                <div onClick={redirectHome} className='text-base flex items-center hover:text-[var(--brand-primary)] gap-4 font-bold pt-1 text-[var(--brand-secondary)] cursor-pointer'><Search className='text-xl'/>Home</div>
                                {/* <div className='text-sm flex items-center gap-3 font-semibold pt-1 text-gray-300 pb-4 border-b border-gray-200 cursor-not-allowed'><TextLeft className='text-xl'/>Content Repository</div> */}
                                <div className="flex">
                                <div className='text-base flex items-center gap-4 font-bold pt-1 text-gray-700 cursor-default'><ClockHistory className='text-xl'/>Query Library</div>
                                {chat_history?.length > 0 && <div className='mt-2 ml-auto mr-4 cursor-pointer text-xs' onClick={handleClear}>Clear</div>}
                                </div>


                                <div className='pl-4 max-h-[30vh] overflow-y-auto listing ml-2 space-y-3 border-l border-gray-400'>
                                {chat_history?.length > 0 && chat_history?.map((history, h_index) => {
                                  return (
                                    <div div className='flex justify-between'>
                    <p title={history?.question} 
                      onClick={() => { 
                        navigate(`/internal_ama/${history.prospect_token}`)
                        if(mobileView) setSideHistoryOpen(false)
                      }} 
                      className={`truncate pr-6 font-medium cursor-pointer hover:text-[var(--brand-primary)] ${id === history.prospect_token ? "text-[var(--brand-primary)]" : "text-gray-700"}`}
                    >
                      {history?.question?.length > 25 ? `${history?.question?.slice(0, 25)}...`: history?.question }
                    </p>
                    <MdDeleteOutline onClick={()=>{handleDelete(history.prospect_token)}}  className='my-auto mr-4 text-lg cursor-pointer'/>
                  </div>
                                  );
                                })}
                                </div>        
                              </div>
                              {/* <div className='border-solid mt-5 border-[1px] border-gray-400 rounded-xl mr-6'>
            <div className='text-sm flex items-center gap-4 font-semibold pt-1 text-[#808080] ml-4 mb-2 mt-1'>Chat Commands</div>
            <div className='border-solid mb-2 mx-2 border-[1.5px] border-[var(--brand-primary)] rounded-xl flex px-3 py-1 justify-between '>
              <div className='my-auto text-[var(--brand-primary)] font-bold text-lg mr-4'>/d</div>
              <div className='text-xs'>Search and retrieve relevant document from library.</div>
            </div>
            <div className='border-solid mb-2 mx-2 border-[1.5px] border-[var(--brand-primary)] rounded-xl flex px-3 py-1 justify-between '>
              <div className='my-auto text-[var(--brand-primary)] font-bold text-lg mr-4'>/t</div>
              <div className='text-xs'>Create a task in your to-do list. Mention date and time.</div>
            </div>
            <div className='border-solid mb-2 mx-2 border-[1.5px] border-[var(--brand-primary)] rounded-xl flex px-3 py-1 justify-between '>
              <div className='my-auto text-[var(--brand-primary)] font-bold text-lg mr-4'>/w</div>
              <div className='text-xs'>Search the web for this prompt.</div>
            </div>
                              </div> */}
                              </div>
                            </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </Dialog>
            </Transition.Root>

            <Transition.Root show={sidebarOpen} as={Fragment}>
              <Dialog
                as="div"
                className="relative z-50 lg:hidden"
                onClose={setSidebarOpen}
              >
                <Transition.Child
                  as={Fragment}
                  enter="transition-opacity ease-linear duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="transition-opacity ease-linear duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-gray-900/80" />
                </Transition.Child>

                <div className="fixed inset-0 flex">
                  <Transition.Child
                    as={Fragment}
                    enter="transition ease-in-out duration-300 transform"
                    enterFrom="-translate-x-full"
                    enterTo="translate-x-0"
                    leave="transition ease-in-out duration-300 transform"
                    leaveFrom="translate-x-0"
                    leaveTo="-translate-x-full"
                  >
                    <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                      <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                          <button
                            type="button"
                            className="-m-2.5 p-2.5"
                            onClick={() => setSidebarOpen(false)}
                          >
                            <span className="sr-only">Close sidebar</span>
                            <XMarkIcon
                              className="h-6 w-6 text-white"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </Transition.Child>
                      {/* Sidebar component, swap this element with another sidebar if you like */}
                      <div className="flex grow flex-col bg-white pl-6 py-4">
                        <div
                          onClick={() => {
                            navigate("/");
                            setSidebarOpen(false);
                          }}
                          className="border-b border-gray-200 flex-shrink-0 pt-4 pb-6 items-center flex justify-between"
                        >
                          <img
                            className="header-logo w-20"
                            src={navLogo}
                            alt={
                              userData && userData?.client_details?.company_name
                            }
                          />
                          {/* {tokenData?.used_prompts >= tokenData?.total_prompts && <FiInfo title={"You've used up all your prompts for this cycle! To continue using Zoi, please wait for the next cycle or purchase a plan with more prompts."}  className='my-auto mr-2 text-sm cursor-pointer'/>} */}
                          {/* <div onClick={()=>{if(tokenData?.used_prompts >= tokenData?.total_prompts){navigate(`/Setting/billing`);}}} className={` ${tokenData?.used_prompts >= tokenData?.total_prompts ? "text-red-500 cursor-pointer" :"cursor-default"} text-sm mr-4 font-[600] my-auto`}>{`${tokenData?.used_prompts}/${tokenData?.total_prompts}`}</div> */}
                          {/* <div onClick={()=>{if(tokenData?.used_prompts >= tokenData?.total_prompts){navigate(`/Setting/billing`);}}} className={` ${tokenData?.used_prompts >= tokenData?.total_prompts ? "text-red-500 cursor-pointer" :"cursor-default"} text-sm mr-4 font-[600] my-auto`}>{`$${totalData?.total_credits}`}</div> */}
                          {/* {uData?.stripeData?.is_trial == 1 && <div className="pr-2 mt-4 hidden max-sm:block">
                            <button
                              type="button"
                              className="relative rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                              {uData?.stripeData?.is_trial == 1 && uData?.stripeData?.stripe_day_count > 0 && <span onClick={() => { navigate("/Setting/billing") }} className={`text-xs ${"bg-[#49BCD2]"} p-2 rounded-sm text-white`}>
                                {`Trial Period Expires in ${uData?.stripeData?.stripe_day_count} Days`}
                              </span>}
                              {uData?.stripeData?.is_trial == 1 && uData?.stripeData?.stripe_day_count == 0 && <span onClick={() => { navigate("/Setting/billing") }} className={`text-xs ${"bg-red-500"} p-2 rounded-sm text-white`}>
                                Trial Expired. Go to Billing.
                              </span>}
                            </button>
                          </div>} */}
                        </div>
                        <div className="overflow-y-auto listing">
                        {navigation.map((main, m_index) => {
                          return (
                            <>
                            {main?.title && <div className="flex items-center">
                              <div>
                                <div
                                  className="text-base font-[600] py-4"
                                  onClick={() => {
                                    navigate(main.route);
                                    setSidebarOpen(false);
                                  }}
                                >
                                  {main.title}
                                </div>

                                {main?.sub_menu.length > 0 && (
                                  <nav className="flex flex-1 flex-col">
                                    <ul
                                      role="list"
                                      className="flex flex-1 flex-col"
                                    >
                                      {main?.sub_menu.map((item) => (
                                        <li key={item.name}>
                                          <span
                                            onClick={() => {
                                              navigate(item.href);
                                              setSidebarOpen(false);
                                            }}
                                            className={classNames(
                                              props.subPageName === item.current
                                                ? "bg-gray-50 text-[var(--brand-primary)]"
                                                : "text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50",
                                              "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                            )}
                                          >
                                            <item.icon
                                              className={classNames(
                                                props.subPageName ===
                                                  item.current
                                                  ? "text-[var(--brand-primary)]"
                                                  : "text-gray-400 group-hover:text-[var(--brand-primary)]",
                                                "h-6 w-6 shrink-0"
                                              )}
                                              aria-hidden="true"
                                            />
                                            {item.name}
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  </nav>
                                )}
                              </div>
                            </div>}
                            </>
                          );
                        })}
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </Dialog>
            </Transition.Root>
          </>
        )}
      </Disclosure>
        <Transition.Root show={show} as={Fragment}>
          <Dialog as="div" className="relative z-10"
          //  initialFocus={cancelButtonRef} 
          onClose={handleClose}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete 
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                               Are you sure you want to delete?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={deleteEvent}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={handleClose}
                        // ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      
    </>
  );
};

export default Navigation;
